import { useEffect } from 'react';
import { Outlet, useRoutes } from 'react-router-dom';
import { useAppSelector } from '@store';
import IndividualCustomers from './routes/individual-customers';
import CorporateCustomers from './routes/corporate-customers';
import NewAppliation from './routes/new-application';
import Customers from './hoc/customers/customers';
import NotificationCenter from './hoc/notification-center/notification-center';

import ROUTES from './routes';

export const routes = {
  path: ROUTES.CUSTOMERS,
  element: <Customers />,
  children: [
    { ...IndividualCustomers },
    { ...CorporateCustomers },
    { ...NewAppliation },
    {
      path: ROUTES.CUSTOMERS_NOTIFICATIONS_CENTER,
      element: <NotificationCenter />,
    },
  ],
};

const CustomersRoutes = () => {
  const elements = useRoutes([
    {
      path: '/',
      element: (
        <Outlet
          context={{
            connectionStatus: null,
            sendMessage: null,
          }}
        />
      ),
      children: [{ ...routes }],
    },
  ]);

  const { whitelabel } = useAppSelector((state) => state.root);

  useEffect(() => {
    if (whitelabel) {
      localStorage.setItem('companyName', whitelabel?.data?.value?.companyName);
    }
  }, [whitelabel]);

  return elements;
};

export default CustomersRoutes;
